const TOKEN_KEY = 'room-mates.token';
/** Where an administrator's own token waits while they are impersonating. */
const ORIGINAL_TOKEN_KEY = 'room-mates.originalToken';

function read(key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

function write(key: string, value: string | null): void {
  try {
    if (value === null) {
      globalThis.localStorage?.removeItem(key);
      return;
    }
    globalThis.localStorage?.setItem(key, value);
  } catch {
    // A session that cannot be remembered still works until the tab closes.
  }
}

/**
 * Token persistence, isolated so tests (and a future move to cookies) touch one
 * file. Guarded because `localStorage` throws in private-mode Safari.
 */
export const sessionStore = {
  read: () => read(TOKEN_KEY),
  readOriginal: () => read(ORIGINAL_TOKEN_KEY),

  write: (token: string) => write(TOKEN_KEY, token),

  /** Swaps in a borrowed session, keeping the real one to come back to. */
  startImpersonation(ownToken: string, borrowedToken: string): void {
    write(ORIGINAL_TOKEN_KEY, ownToken);
    write(TOKEN_KEY, borrowedToken);
  },

  /** Puts the administrator back in their own session. */
  endImpersonation(): string | null {
    const original = read(ORIGINAL_TOKEN_KEY);
    write(ORIGINAL_TOKEN_KEY, null);
    write(TOKEN_KEY, original);
    return original;
  },

  clear(): void {
    write(TOKEN_KEY, null);
    write(ORIGINAL_TOKEN_KEY, null);
  },
};
